import type { IconSvgObject } from './types';

const PiSquareIcon: IconSvgObject = [
  ["path", { d: "M17 8H10.2222C8.99492 8 8 8.89543 8 10M11.3333 8L10.3738 14.9086C10.2905 15.5083 9.67713 15.9299 9.01245 15.8445C8.5622 15.7866 8.18693 15.5047 8.04309 15.1164L8 15M13.6667 16L14.7778 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2.5 19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V4.50043C21.5 3.39589 20.6046 2.50046 19.5001 2.50043L4.50005 2.50005C3.39546 2.50002 2.5 3.39546 2.5 4.50005V19.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PiSquareIcon;
